import { useState, useEffect } from "react";
import { useGlobalContext } from "../../../../../Context/Context";
import CustomSelect from "../CustomSelect";
import CustomNumInput from "./CustomNumInput";
import Button from "../../../../Custom/Button/Button";
import backImg from "../../../../../picture/Back.png";

const styles = {
  input: {
    width: "100%",
    fontSize: "16px",
    height: "40px",
    padding: "10px",
  },
  btn: {
    fontWeight: "bold",
    padding: "10px",
  },
};

const zaposlenMock = {
  ime: "",
  srednjeIme: "",
  prezime: "",
  maticniBroj: "",
  datumRodjenja: "",
  adresa: "",
  kontaktTelefon: "",
  emailAdresa: "",
  brojLicneKarte: "",
  strucnaSprema: { id: -1, name: "" },
  oblastSpreme: { id: -1, name: "" },
  vozackaDozvola: { id: -1, name: "" },
  maternjiJezik: { id: -1, name: "" },
  radnoMesto: { id: -1, name: "" },
  poslovnaJedinica: { id: -1, name: "" },
  pocetakRada: "",
  odeca: "",
  obuca: "",
  slika: null,
};

function DodavanjeZaposlenog({ setCurrentState, editZaposlenData, onSaved }) {
  const {
    loggedUser,
    apiKey,
    companyId,
    baseUrl,
    dictionary,
    selectedMainEntity,
  } = useGlobalContext();
  const [zaposlen, setZaposlen] = useState(zaposlenMock);

  const [liste, setListe] = useState({
    spreme: [],
    oblasti: [],
    dozvole: [],
    jezici: [],
    radnaMesta: [],
    jedinice: [],
  });

  useEffect(() => {
    const fetchFullData = async () => {
      if (editZaposlenData && editZaposlenData.id && liste.spreme.length > 0) {
        try {
          const response = await fetch(
            `${baseUrl}/zaposleni/read_one.php?id=${editZaposlenData.id}`,
          );
          const result = await response.json();
          if (result.status === 200) {
            const d = result.data;
            setZaposlen({
              ...zaposlenMock,
              ime: d.ime || "",
              srednjeIme: d.srednje_ime || "",
              prezime: d.prezime || "",
              maticniBroj: d.maticni_broj || "",
              datumRodjenja: d.datum_rodjenja || "",
              adresa: d.adresa || "",
              kontaktTelefon: d.telefon || "",
              emailAdresa: d.email || "",
              brojLicneKarte: d.broj_licne_karte || "",
              odeca: d.velicina_odece != null ? Number(d.velicina_odece) : "",
              obuca: d.velicina_obuce != null ? Number(d.velicina_obuce) : "",
              pocetakRada: d.pocetak_rada || "",
              strucnaSprema: liste.spreme.find((i) => i.id == d.spreme_id) || {
                id: -1,
                name: "",
              },
              oblastSpreme: liste.oblasti.find(
                (i) => i.id == d.oblast_spreme_id,
              ) || { id: -1, name: "" },
              vozackaDozvola: liste.dozvole.find(
                (i) => i.id == d.vozacke_dozvole_id,
              ) || { id: -1, name: "" },
              maternjiJezik: liste.jezici.find(
                (i) => i.id == d.strani_jezici_id,
              ) || { id: -1, name: "" },
              radnoMesto: liste.radnaMesta.find(
                (i) => i.id == d.workplace_id,
              ) || { id: -1, name: "" },
              poslovnaJedinica: liste.jedinice.find(
                (i) => i.id == d.poslovna_jedinica_id,
              ) || { id: -1, name: "" },
              slika: null,
            });
          }
        } catch (err) {
          console.error("Greška pri učitavanju podataka zaposlenog:", err);
        }
      }
    };
    fetchFullData();
  }, [editZaposlenData, liste, baseUrl]);

  useEffect(() => {
    fetch(
      `${baseUrl}/employees1/get_form_data.php?company_id=${selectedMainEntity.company_id}`,
    )
      .then((res) => res.json())
      .then((data) => {
        setListe(data);
      })
      .catch((err) => console.error("Greška pri učitavanju šifrarnika:", err));
  }, [baseUrl, companyId]);

  const handleChange = (field, value) => {
    setZaposlen((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    if (!zaposlen.ime || !zaposlen.prezime) {
      alert("Ime i prezime su obavezni.");
      return;
    }

    if (zaposlen.radnoMesto.id === -1) {
      alert("Radno mesto je obavezno.");
      return;
    }

    const formData = new FormData();
    formData.append("id", editZaposlenData ? editZaposlenData.id : "");
    formData.append("user_id", loggedUser.id);
    formData.append("api_key", apiKey);
    formData.append("company_id", selectedMainEntity.company_id || 1);
    formData.append("ime", zaposlen.ime);
    formData.append("srednje_ime", zaposlen.srednjeIme);
    formData.append("prezime", zaposlen.prezime);
    formData.append("maticni_broj", zaposlen.maticniBroj);
    formData.append("datum_rodjenja", zaposlen.datumRodjenja || "");
    formData.append("adresa", zaposlen.adresa);
    formData.append("telefon", zaposlen.kontaktTelefon);
    formData.append("email", zaposlen.emailAdresa);
    formData.append("broj_licne_karte", zaposlen.brojLicneKarte);
    formData.append(
      "spreme_id",
      zaposlen.strucnaSprema.id !== -1 ? zaposlen.strucnaSprema.id : "",
    );
    formData.append(
      "oblast_spreme_id",
      zaposlen.oblastSpreme.id !== -1 ? zaposlen.oblastSpreme.id : "",
    );
    formData.append(
      "vozacke_dozvole_id",
      zaposlen.vozackaDozvola.id !== -1 ? zaposlen.vozackaDozvola.id : "",
    );
    formData.append(
      "strani_jezici_id",
      zaposlen.maternjiJezik.id !== -1 ? zaposlen.maternjiJezik.id : "",
    );
    formData.append(
      "workplace_id",
      zaposlen.radnoMesto.id !== -1 ? zaposlen.radnoMesto.id : "",
    );
    formData.append(
      "poslovna_jedinica_id",
      zaposlen.poslovnaJedinica.id !== -1 ? zaposlen.poslovnaJedinica.id : "",
    );
    formData.append("pocetak_rada", zaposlen.pocetakRada || "");
    formData.append(
      "velicina_odece",
      zaposlen.odeca !== "" ? zaposlen.odeca : "",
    );
    formData.append(
      "velicina_obuce",
      zaposlen.obuca !== "" ? zaposlen.obuca : "",
    );
    formData.append("status_zaposlenog", "AKTIVAN");
    if (zaposlen.slika) formData.append("slika", zaposlen.slika);

    try {
      const endpoint = editZaposlenData
        ? `${baseUrl}/zaposleni/update.php`
        : `${baseUrl}/zaposleni/create.php`;

      const response = await fetch(endpoint, {
        method: "POST",
        body: formData,
      });

      const resData = await response.json();
      console.log("editZaposlenData:", editZaposlenData);

      if (resData.status === 201 || resData.status === 200) {
        onSaved?.();
        window.dispatchEvent(new Event("zaposleniSaved"));
        setCurrentState("");
      } else {
        alert("Greška: " + resData.message);
      }
    } catch (err) {
      console.error("Network Error:", err);
      alert("Došlo je do greške u povezivanju.");
    }
  };

  const handleBack = () => setCurrentState("");

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
      {/* Upload slike */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          marginBottom: "5px",
        }}
      >
        <label
          htmlFor="emp_img"
          style={{
            fontSize: "16px",
            padding: 10,
            fontWeight: "bold",
            color: "#555",
          }}
          className="dos-btn"
        >
          ФОТОГРАФИЈА
        </label>
        <input
          id="emp_img"
          type="file"
          accept="image/jpeg,image/png,image/webp"
          onChange={(e) => {
            const file = e.target.files[0];
            if (file) handleChange("slika", file);
          }}
          style={{ width: "100%", fontSize: "14px", cursor: "pointer" }}
        />
      </div>

      <input
        value={zaposlen.ime}
        onChange={(e) => handleChange("ime", e.target.value)}
        placeholder={dictionary["ime"]}
        style={styles.input}
      />

      <input
        value={zaposlen.srednjeIme}
        onChange={(e) => handleChange("srednjeIme", e.target.value)}
        placeholder={dictionary["srednjeIme"]}
        style={styles.input}
      />
      <input
        value={zaposlen.prezime}
        onChange={(e) => handleChange("prezime", e.target.value)}
        placeholder={dictionary["prezime"]}
        style={styles.input}
      />
      <input
        value={zaposlen.maticniBroj}
        onChange={(e) => handleChange("maticniBroj", e.target.value)}
        placeholder="Matični broj"
        style={styles.input}
        maxLength={13}
      />
      <input
        type="date"
        value={zaposlen.datumRodjenja}
        onChange={(e) => handleChange("datumRodjenja", e.target.value)}
        style={styles.input}
      />
      <input
        value={zaposlen.adresa}
        onChange={(e) => handleChange("adresa", e.target.value)}
        placeholder={dictionary["adresa"]}
        style={styles.input}
      />
      <input
        value={zaposlen.kontaktTelefon}
        onChange={(e) => handleChange("kontaktTelefon", e.target.value)}
        placeholder={dictionary["kontaktTelefon"]}
        style={styles.input}
      />
      <input
        value={zaposlen.emailAdresa}
        onChange={(e) => handleChange("emailAdresa", e.target.value)}
        placeholder={dictionary["emailAdresa"]}
        style={styles.input}
      />
      <input
        value={zaposlen.brojLicneKarte}
        onChange={(e) => handleChange("brojLicneKarte", e.target.value)}
        placeholder={dictionary["brojLicneKarte"]}
        style={styles.input}
        maxLength={9}
      />

      <CustomSelect
        label={dictionary["strucnaSprema"]}
        allValues={liste.spreme}
        selectedValue={zaposlen.strucnaSprema}
        onSelectChange={(v) => handleChange("strucnaSprema", v)}
      />
      <CustomSelect
        label={dictionary["oblastSpreme"]}
        allValues={liste.oblasti}
        selectedValue={zaposlen.oblastSpreme}
        onSelectChange={(v) => handleChange("oblastSpreme", v)}
      />
      <CustomSelect
        label={dictionary["vozackaDozvola"]}
        allValues={liste.dozvole}
        selectedValue={zaposlen.vozackaDozvola}
        onSelectChange={(v) => handleChange("vozackaDozvola", v)}
      />
      <CustomSelect
        label={dictionary["maternjiJezik"]}
        allValues={liste.jezici}
        selectedValue={zaposlen.maternjiJezik}
        onSelectChange={(v) => handleChange("maternjiJezik", v)}
      />

      <div style={{ display: "flex", gap: "5px" }}>
        <CustomNumInput
          selectedValue={zaposlen.odeca}
          label={dictionary["odeca"]}
          min={30}
          max={60}
          onChange={(v) => handleChange("odeca", v)}
        />
        <CustomNumInput
          selectedValue={zaposlen.obuca}
          label={dictionary["obuca"]}
          min={30}
          max={50}
          onChange={(v) => handleChange("obuca", v)}
        />
      </div>

      <CustomSelect
        label={dictionary["radnoMesto"]}
        allValues={liste.radnaMesta}
        selectedValue={zaposlen.radnoMesto}
        onSelectChange={(v) => handleChange("radnoMesto", v)}
      />
      <CustomSelect
        label={dictionary["poslovnaJedinica"]}
        allValues={liste.jedinice}
        selectedValue={zaposlen.poslovnaJedinica}
        onSelectChange={(v) => handleChange("poslovnaJedinica", v)}
      />
      <input
        type="date"
        value={zaposlen.pocetakRada}
        onChange={(e) => handleChange("pocetakRada", e.target.value)}
        style={styles.input}
      />

      <div style={{ display: "flex" }}>
        {!editZaposlenData && (
          <div onClick={handleBack} style={{ width: "25%" }}>
            <Button activation={true}>
              <img src={backImg} style={{ width: "20px" }} />
            </Button>
          </div>
        )}
        <div
          onClick={handleSubmit}
          style={{ width: editZaposlenData ? "100%" : "75%" }}
        >
          <Button activation={true} style={styles.btn}>
            {editZaposlenData ? dictionary["azuriraj"] : dictionary["dodaj"]}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default DodavanjeZaposlenog;
